import React, { ReactElement } from 'react';
import Layout from './Layout';

export default (): ReactElement => (
  <Layout withoutNavLinks>
    <h1>Nie ste prihlásený</h1>
    <p>
      Prihláste sa prosím do aplikácie slovlex.
    </p>
  </Layout>
);
